// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const EXPIRE_CURRENT_ORDER_CONFIGURATION = {
  ...GIL_API_CHANNEL,
  endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/cancel',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
};

export { EXPIRE_CURRENT_ORDER_CONFIGURATION };
